(ns measure.reporting-ocp.view.tabs.fields
  (:require [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [measure.reporting-ocp.db.core :as form]
            [measure.reporting-ocp.db.options :as form-options]
            [reagent.core :as r]
            [uix.core :refer [$ defui defhook]]))

(defui metrics-field []
  (let [metric-options (form-options/use-metric-options)]
    ($ form-field
       {:label "Metrics"}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:event-types])
                         {:options metric-options
                          :multi? true
                          :auto-focus? true})]))))
